import React, {useEffect, useRef, useState} from "react";
import {Badge, Button, Col, Modal, Row, Spinner} from "react-bootstrap";
import CameraAccess from "../../Payroll/cameraAccess";
import BarcodeScanner from "react-qr-barcode-scanner/dist/BarcodeScanner";
import {isEmpty} from "../../../../../_helpers/commonFunctions";
import moment from "moment/moment";
import axios from "axios";
import {useDispatch, useSelector} from "react-redux";
import {toast} from "react-toastify";
import {
    setAutoTransfer,
    setInvoicesTable, setTransferOpenRows, setTransferSelectedRows,
} from "../../../../../_reducers/DataPanel/Sales/transfersSlice";
import {FaListUl, FaRegTrashAlt} from "react-icons/fa";
import Input from "../../../../common/Input";
import {BsQrCodeScan} from "react-icons/bs";
import {LuTextCursorInput} from "react-icons/lu";
import {
    formatDeliveryStatus,
    formatDeliveryStatusColor,
} from "./constants";
import "./transfersStyles.css";
import {MdOutlineDeleteSweep} from "react-icons/md";
import {TransferInfo} from "./TransferInfo";
import {selfUpdateSaleByMark} from "../../../../../_helpers/tabUpdater";
import SelectFromSalesModal from "./SelectFromSalesModal";
import TransfersActionButtons from "./TransfersActionButtons";

const NewTransfer = () => {
    const dispatch = useDispatch();
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const invoicesTable = useSelector((state) => state.TRANSFERS.invoicesTable);
    const selectedRows = useSelector((state) => state.TRANSFERS.selectedRows);
    const openRows = useSelector((state) => state.TRANSFERS.openRows);
    const autoTransfer = useSelector((state) => state.TRANSFERS.autoTransfer);
    const editSales = useSelector((state) => state.SALES.editSales);

    const [showScanningModal, setShowScanningModal] = useState(false);
    const [enableQRReader, setEnableQRReader] = useState(false);
    const [backgroundQuickColor, setBackgroundQuickColor] = useState("white");
    const [qrResult, setQRResult] = useState("");
    const [selectedCamera, setSelectedCamera] = useState("");
    const [cameraDevices, setCameraDevices] = useState([]);
    const [cameraIdx, setCameraIdx] = useState(0);

    const [showInputModal, setShowInputModal] = useState(false);
    const [inputModalInput, setInputModalInput] = useState("");

    const lastScan = useRef(moment());
    const waitingResponse = useRef(false);

    const [showCleanInvoiceTable, setShowCleanInvoiceTable] = useState(false);
    const [showSelectSales, setShowSelectSales] = useState(false);

    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (enableQRReader && cameraDevices.length === 0) {
            navigator.mediaDevices.enumerateDevices().then((devices) => {
                const videoDevices = devices.filter((device) => device.kind === "videoinput");
                setCameraDevices(videoDevices);
                if (videoDevices.length > 0) {
                    setSelectedCamera(videoDevices[0].deviceId); // Set the first camera by default
                    setCameraIdx(0);
                }
            });
        }
    }, [enableQRReader]);

    useEffect(() => {
        if (autoTransfer) {
            dispatch(setAutoTransfer(null));
            handleTransferURL(autoTransfer.qrUrl);
        }
    }, [autoTransfer]);

    useEffect(() => {
        if (!isEmpty(qrResult)) handleQRScan(qrResult);
    }, [qrResult])

    const handleQRScan = (qrUrl) => {
        if (moment().diff(lastScan.current, "seconds") > 2 && !waitingResponse.current) {
            lastScan.current = moment();
            setQRResult("");
            if (invoicesTable.some((el) => el.qrUrl === qrUrl)) return toast.info("Έχετε ήδη σκανάρει το παρόν παραστατικό.");
            handleTransferURL(qrUrl);
        }
    }

    const qrBackground = (type) => {
        if (type === "green") setBackgroundQuickColor("#a1ffa3");
        else if (type === "red") setBackgroundQuickColor("#ff8b8b");

        setTimeout(() => {
            setBackgroundQuickColor("white");
        }, 1000)
    }

    const handleTransferURL = (qrUrl) => {
        const qrReq = qrUrl || inputModalInput;
        setLoading(true);
        waitingResponse.current = true;
        axios.post(`${process.env.REACT_APP_API_URL2}/sale/transfer-url-validity`, {
            qrUrl: qrReq,
            company: company.id,
        }).then((res) => {
            if (res.data.status === "200") {
                if (res.data.isGroup) {
                    setShowScanningModal(false);
                    qrBackground("green");
                    dispatch(setInvoicesTable(res.data.data));
                    dispatch(setTransferSelectedRows(res.data.data.map((o) => o.qrUrl)));
                    dispatch(setTransferOpenRows([]));
                    toast.success("Επιτυχής καταχώρηση group.");
                } else {
                    setShowScanningModal(false);
                    const downloadingInvoiceUrl = res.data.data.qrUrl;
                    if (invoicesTable.some((el) => el.qrUrl === downloadingInvoiceUrl)) {
                        qrBackground("red");
                        toast.info("Έχετε ήδη σκανάρει το παρόν παραστατικό.");
                    } else {
                        qrBackground("green");
                        dispatch(setInvoicesTable([...invoicesTable, res.data.data]));
                        dispatch(setTransferSelectedRows([...selectedRows, downloadingInvoiceUrl]));
                        dispatch(setTransferOpenRows([downloadingInvoiceUrl]));
                        toast.success("Επιτυχής καταχώρηση παραστατικού.");
                    }
                }
            } else {
                qrBackground("red");
                toast.error(res.data.message);
            }
        }).catch((axiosError) => {
            qrBackground("red");
            console.log(axiosError);
            toast.error("Σφάλμα κατά την αποστολή αιτήματος.");
        }).finally(() => {
            if (showInputModal) {
                setShowInputModal(false);
                setInputModalInput("");
            }
            setLoading(false);
            waitingResponse.current = false;
        });
    }

    const refreshTransfers = () => {
        axios.post(`${process.env.REACT_APP_API_URL2}/sale/get-transfers`, {
            qrUrls: invoicesTable.map((o) => o.qrUrl),
            company: company.id,
        }).then((res) => {
            if (res.data.status === "200") {
                dispatch(setInvoicesTable(res.data.data));
            }
        }).catch((err) => {
            console.log(err);
        })
    }

    return (
        <React.Fragment>
            <Row className={"mb-2"}>
                <Col md={12} className="d-flex flex-row justify-content-between align-items-center">
                    <div className="d-flex gap-1 gap-md-2">
                        <Button
                            size={"sm"}
                            onClick={() => setShowScanningModal(true)}
                            className="text-nowrap d-flex align-items-center"
                        >
                            <BsQrCodeScan size={16} className="me-1" />
                            <span className="d-none d-sm-inline">Σκαννάρισμα</span>
                            <span className="d-inline d-sm-none">Σκαννάρισμα</span>
                        </Button>

                        <Button
                            size={"sm"}
                            onClick={() => setShowInputModal(true)}
                            className="text-nowrap d-flex align-items-center"
                        >
                            <LuTextCursorInput size={16} className="me-1" />
                            <span className="d-none d-sm-inline">Χειροκίνητη Εισαγωγή</span>
                            <span className="d-inline d-sm-none">Χειροκίνητη Εισαγωγή</span>
                        </Button>

                        <Button
                            size={"sm"}
                            onClick={() => setShowSelectSales(true)}
                            className="text-nowrap d-flex align-items-center"
                        >
                            <FaListUl size={16} className="me-1" />
                            <span className="d-none d-sm-inline">Επιλογή από πωλήσεις</span>
                            <span className="d-inline d-sm-none">Επιλογή από πωλήσεις</span>
                        </Button>
                    </div>

                    <div className="d-flex align-items-center">
                        {loading ? (
                            <div className="d-flex align-items-center me-2">
                                <Spinner size={"sm"} animation={"border"} variant={"dark"}/>
                            </div>
                        ) : (
                            invoicesTable.length > 0 && (
                                <Button
                                    size={"sm"}
                                    variant={"outline-danger"}
                                    onClick={() => setShowCleanInvoiceTable(true)}
                                    className="p-1 p-md-2"
                                >
                                    <MdOutlineDeleteSweep size={18} />
                                    <span className="d-none d-md-inline ms-1">Καθαρισμός Πίνακα</span>
                                </Button>
                            )
                        )}
                    </div>
                </Col>
            </Row>
            <Row className={"mb-3"}>
                <Col md={12}>
                    <table className={"transfers-table responsive-table"}>
                        <thead>
                        <tr>
                            <th onClick={(e) => {
                                e.stopPropagation();
                                if (selectedRows.length === invoicesTable.length) {
                                    dispatch(setTransferSelectedRows([]));
                                } else {
                                    dispatch(setTransferSelectedRows(invoicesTable.map((o) => o.qrUrl)));
                                }
                            }}>
                                {invoicesTable.length > 0 && (
                                    <input
                                        type={"checkbox"}
                                        className={"mt-1"}
                                        style={{zoom: 1.5}}
                                        checked={selectedRows.length === invoicesTable.length}
                                    />
                                )}
                            </th>
                            <th>Ημ/νια Έκδοσης</th>
                            <th>Εκδότης</th>
                            <th>Λήπτης</th>
                            <th>MARK</th>
                            <th>Παραστατικό</th>
                            <th>B2B / B2C</th>
                            <th>Κατάσταση</th>
                            <th>Ενέργειες</th>
                        </tr>
                        </thead>
                        <tbody>
                        {invoicesTable.map((t, idx) => (
                            <React.Fragment key={`frag-${idx}`}>
                                <tr
                                    style={{cursor: "pointer"}}
                                    onClick={() => {
                                        if (openRows.includes(t.qrUrl)) {
                                            dispatch(setTransferOpenRows(openRows.filter((el) => el !== t.qrUrl)));
                                        } else {
                                            dispatch(setTransferOpenRows([...openRows, t.qrUrl]));
                                        }
                                    }}
                                >
                                    <td data-label="Επιλογή" onClick={(e) => {
                                        e.stopPropagation();
                                        if (selectedRows.includes(t.qrUrl)) {
                                            dispatch(setTransferSelectedRows(selectedRows.filter((el) => el !== t.qrUrl)));
                                        } else {
                                            dispatch(setTransferSelectedRows([...selectedRows, t.qrUrl]));
                                        }
                                    }}>
                                        <input type={"checkbox"} className={"mt-1"} style={{zoom: 1.5}} checked={selectedRows.includes(t.qrUrl)} />
                                    </td>
                                    <td data-label="Ημ/νια Έκδοσης">{moment(t.invoiceDate).format("DD/MM/YYYY")}</td>
                                    <td data-label="Εκδότης" className="text-truncate-mobile">{t.issuerName}</td>
                                    <td data-label="Λήπτης" className="text-truncate-mobile">{t.counterpartName}</td>
                                    <td data-label="MARK" className="text-truncate-mobile">{t.invoiceMark}</td>
                                    <td data-label="Παραστατικό">{t.documentLabel}</td>
                                    <td data-label="B2B / B2C">{t.isB2B ? "B2B" : "B2C"}</td>
                                    <td data-label="Κατάσταση" style={{backgroundColor: formatDeliveryStatusColor(t.myDataStatus)}}>
                                        {formatDeliveryStatus(t.myDataStatus)}
                                    </td>
                                    <td data-label="Ενέργειες">
                                        <Badge bg={"danger"} onClick={(e) => {
                                            e.stopPropagation();
                                            dispatch(setInvoicesTable(invoicesTable.filter((el) => el.qrUrl !== t.qrUrl)));
                                            dispatch(setTransferSelectedRows(selectedRows.filter((el) => el !== t.qrUrl)));
                                            dispatch(setTransferOpenRows(openRows.filter((el) => el !== t.qrUrl)));
                                        }}><FaRegTrashAlt /></Badge>
                                    </td>
                                </tr>
                                {openRows.includes(t.qrUrl) && (
                                    <tr key={`tr-d-${idx}-o`} className="expanded-row-mobile">
                                        <td colSpan={9}>
                                            <TransferInfo
                                                transferData={t}
                                                refreshCallback={() => {
                                                    refreshTransfers();
                                                    // Self-update sales
                                                    const marks = invoicesTable.filter((el) => selectedRows.includes(el.qrUrl)).map((o) => String(o.invoiceMark));
                                                    for (const mark of marks) selfUpdateSaleByMark(dispatch, editSales, company.id, mark);
                                                }}
                                            />
                                        </td>
                                    </tr>
                                )}
                            </React.Fragment>
                        ))}
                        </tbody>
                    </table>
                </Col>
            </Row>

            <TransfersActionButtons
                selectedRows={invoicesTable.filter((el) => selectedRows.includes(el.qrUrl))}
                successCallback={() => {
                    refreshTransfers();
                    // Self-update sales
                    const marks = invoicesTable.filter((el) => selectedRows.includes(el.qrUrl)).map((o) => String(o.invoiceMark));
                    for (const mark of marks) selfUpdateSaleByMark(dispatch, editSales, company.id, mark);
                }}
            />

            <Modal show={showScanningModal} onHide={() => setShowScanningModal(false)} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Σκαννάρισμα QR</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {showScanningModal && (
                        <div style={{
                            position: "relative",
                            borderRadius: "12px",
                            border: `1px solid ${backgroundQuickColor === "white" ? "#6ea2a9" : backgroundQuickColor}`,
                            height: "100%",
                            backgroundColor: backgroundQuickColor
                        }}>
                            {!enableQRReader ? (
                                <CameraAccess accessGrantedFunction={(val) => setEnableQRReader(val)} />
                            ) : (
                                <React.Fragment>
                                    <div style={{paddingLeft: "5%", paddingRight: "5%", margin: "2%"}}>
                                        <BarcodeScanner
                                            delay={500}
                                            onUpdate={(error, result) => {
                                                if (result && !isEmpty(result?.getText())) {
                                                    setQRResult(result.getText());
                                                } else {
                                                    setQRResult("");
                                                }
                                            }}
                                            videoConstraints={{
                                                deviceId: { exact: selectedCamera },
                                            }}
                                        />
                                    </div>
                                    {cameraDevices.length > 1 && (
                                        <div style={{textAlign: "center"}}>
                                            <Button size={"sm"} onClick={() => {
                                                setEnableQRReader(false);
                                                setTimeout(() => {
                                                    if (!cameraDevices[cameraIdx + 1]) {
                                                        setSelectedCamera(cameraDevices[0].deviceId);
                                                        setCameraIdx(0);
                                                    } else {
                                                        setSelectedCamera(cameraDevices[cameraIdx + 1].deviceId);
                                                        setCameraIdx(cameraIdx + 1);
                                                    }
                                                    setTimeout(() => {
                                                        setEnableQRReader(true);
                                                    }, 250);
                                                }, 250);
                                            }}>Εναλλαγή κάμερας</Button>
                                        </div>
                                    )}
                                </React.Fragment>
                            )}
                        </div>
                    )}
                </Modal.Body>
            </Modal>

            <Modal show={showInputModal} onHide={() => setShowInputModal(false)} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Χειροκίνητη Εισαγωγή</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Input
                        name={"inputModalInput"}
                        label={"URL"}
                        value={inputModalInput}
                        allowSpecialCharacters={true}
                        onChange={(e) => setInputModalInput(e.target.value)}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowInputModal(false)}>
                        Κλείσιμο
                    </Button>
                    <Button variant="primary" onClick={() => handleTransferURL()} disabled={loading}>
                        Καταχώρηση {loading && <Spinner className={"ml-2"} animation={"border"} variant={"dark"} />}
                    </Button>
                </Modal.Footer>
            </Modal>

            <SelectFromSalesModal
                show={showSelectSales}
                setShow={setShowSelectSales}
                invoicesTable={invoicesTable}
                callbackFunction={(selectedTranfers) => {
                    dispatch(setInvoicesTable([...invoicesTable, ...selectedTranfers]));
                    dispatch(setTransferSelectedRows([...selectedRows, ...selectedTranfers.map((o) => o.qrUrl)]));
                    setShowSelectSales(false);
                    toast.success("Επιτυχής μεταφορά στον πίνακα.");
                }}
            />

            <Modal show={showCleanInvoiceTable} onHide={() => setShowCleanInvoiceTable(false)} backdrop={"static"}>
                <Modal.Header closeButton>
                    <Modal.Title>Καθαρισμός πίνακα Δ.Α.</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Είσαστε σίγουροι ότι θέλετε να αδειάσετε τον πίνακα τον Δελτίων Αποστολής;
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShowCleanInvoiceTable(false)}>
                        Όχι, κλείσιμο
                    </Button>
                    <Button variant="primary" onClick={() => {
                        dispatch(setInvoicesTable([]));
                        dispatch(setTransferSelectedRows([]));
                        dispatch(setTransferOpenRows([]));
                        setShowCleanInvoiceTable(false);
                    }}>
                        Ναι, άδειασμα
                    </Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default NewTransfer;
